module.exports = __WEBPACK_EXTERNAL_MODULE_792__;


//////////////////
// WEBPACK FOOTER
// external "weaWorkflow"
// module id = 792
// module chunks = 2